import { Injectable } from '@angular/core';
import { SavedSearch } from './saved-search.dto';

@Injectable()
export abstract class SavedSearchService {
  abstract get(divisionId: string, id: string): Promise<SavedSearch>;
  abstract create(create: Partial<SavedSearch>): Promise<SavedSearch>;
  abstract update(update: SavedSearch): Promise<void>;
  abstract delete(division: string, id: string): Promise<void>;
}
